import { Helmet } from 'react-helmet-async';

// Get current domain dynamically (works for both www and non-www)
const getBaseUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  // Fallback for SSR or build time
  return 'https://sharvalabs.com';
};

function SEO({ 
  title = 'Sharva Labs - Text Analysis & Word Frequency Tools',
  description = 'Analyze text and discover the top 5 most frequent meaningful words. Advanced word frequency analysis tool with stop word filtering.',
  keywords = 'text analysis, word frequency, word counter, text analyzer, word frequency analyzer, content analysis, stop words',
  url,
  path = '/',
  image,
  type = 'website'
}) {
  // Use dynamic base URL
  const baseUrl = getBaseUrl();
  const fullUrl = url || `${baseUrl}${path}`;
  const ogImage = image || `${baseUrl}/static/og-image.png`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
}

export default SEO;

